import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule, provideDefaultConfig} from '@spartacus/core';
import {ConfiguratorAttributeCompositionConfig} from '@spartacus/product-configurator/rulebased';
import {InputModule, QuantityModule, TooltipModule} from 'ng-design-system';
import {ReactiveFormsModule} from '@angular/forms';
import {KeyboardFocusModule} from '@spartacus/storefront';
import {DcpConfiguratorAttributeSpendAmountComponent} from './dcp-configurator-attribute-spend-amount.component';
import {IconButtonTooltipModule} from '../shared/icon-button-tooltip/icon-button-tooltip.module';

@NgModule({
  imports: [
    CommonModule,
    QuantityModule,
    ReactiveFormsModule,
    KeyboardFocusModule,
    TooltipModule,
    InputModule,
    I18nModule,
    IconButtonTooltipModule,
  ],
  providers: [
    provideDefaultConfig({
      productConfigurator: {
        assignment: {
          AttributeType_numeric___spend_amount: DcpConfiguratorAttributeSpendAmountComponent,
        },
      },
    } as ConfiguratorAttributeCompositionConfig),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [DcpConfiguratorAttributeSpendAmountComponent],
  exports: [DcpConfiguratorAttributeSpendAmountComponent],
})
export class DcpConfiguratorAttributeSpendAmount {}
